import { useFeature } from '@inflearn/hackle';

export const AGREED_OVER_14_FEATURE_KEY = 261;

export const useAgreedOver14Feature = () => {
  const isFeatureOn = useFeature(AGREED_OVER_14_FEATURE_KEY);

  return { isAgreedOver14FeatureOn: isFeatureOn };
};
